const Apiurl = "https://staging-quotation-api1.ris-app.in/public/api/";   // testing
// const Apiurl = "https://quotationsapis.groheapp.in/public/api/";   // production
// const Apiurl = "http://127.0.0.1:8000/api/";     // local

export default Apiurl;